import * as $ from 'jquery'
import {onMouseUp} from "./utilities";
import * as d3 from "d3";
import {getWidthByFontSize} from "./utilities";

export const tableElements = ['tbody', 'thead', 'tfoot', 'th', 'td', 'tr']
export const textNodes = ['p', 'v', 'subtitle', 'th', 'td', 'text-author', 'date']
export const skipTags = ['title', 'div', 'sup', 'sub', 'strong', 'strikethrough', 'code', 'epigraph', 'poem',
  'stanza', 'section', 'cite', 'table', 'image', 'img', 'cite', 'a', 'emphasis']

export const scrollBy = (x, y, container) => {
  let dir = 1

  if (x) container.scrollLeft += x * dir;
  if (y) container.scrollTop += y;
}

export const fixTextPosition = (page, textFlow, elOffs, type = 'none') => {
  let el = type === 'id' ? $('#' + page)[0] : $('[page-num="'+page+'"]')[0]
  if (type === 'el') {
    el = page
  } else if (elOffs) {
    el = getBookmarkOffsEl(page, elOffs)
  }
  let xmlPage = document.getElementsByClassName('xml-page')[0]
  let viewerContent = document.getElementById('viewer-content')
  let viewer = document.getElementById('viewer')
  let container = document.getElementById('viewer').getElementsByTagName('div')[0]
    .getElementsByTagName('div')[0]
  let vOffs = viewerContent.offsetWidth
  if (textFlow === 'scrolling') vOffs = viewer.offsetHeight + viewer.offsetTop
  let offs = el ? el.offsetLeft : 0
  if (textFlow === 'scrolling') offs = el ? el.offsetTop : 0

  let count = Math.ceil(xmlPage.scrollWidth/vOffs)
  if (textFlow === 'scrolling') count = Math.ceil(container.scrollHeight/vOffs)
  for (let i=0; i < count; i++) {
    if (offs > vOffs*i && offs < vOffs*(i+1)) {
      let scroll = vOffs*i
      if (textFlow === 'scrolling') {
        container.scrollTop = type === 'note' ? offs : scroll
      } else {
        viewerContent.scrollLeft = scroll
      }
      break
    }
  }
}

export const fixPosition = (offset) => {
  let xmlPage = document.getElementsByClassName('xml-page')[0]
  let container = document.getElementById('viewer-content')
  let vOffs = container.offsetWidth
  if (!xmlPage) return
  let w = xmlPage.scrollWidth
  let count = Math.ceil(w/vOffs)
  for (let i=0; i < count; i++) {
    if (offset > vOffs*i && offset < vOffs*(i+1)) {
      let scroll = vOffs*i
      container.scrollLeft = scroll
    }
  }
}

export const nextPage = (textFlow) => {
  let container = document.getElementById('viewer-content')
  let delta = container.offsetWidth

  if (textFlow === 'scrolling') {
    container = document.getElementById('viewer').getElementsByTagName('div')[0]
      .getElementsByTagName('div')[0]
    let height = container.offsetHeight
    let top = container.scrollTop + container.offsetHeight;

    if (top < container.scrollHeight) {
      scrollBy(0, height, container)
    }
  } else {
    /*let left = container.scrollLeft + container.offsetWidth
    if (left+delta >= container.scrollWidth) {
      scrollBy(delta, 0, container)
    } else if (left < container.scrollWidth) {
      scrollBy(delta, 0, container)
    }*/
    scrollBy(delta, 0, container)
  }
}

export const prevPage = (textFlow) => {
  let container = document.getElementById('viewer-content')
  let delta = container.offsetWidth

  if (textFlow === 'scrolling') {
    container = document.getElementById('viewer').getElementsByTagName('div')[0]
      .getElementsByTagName('div')[0]
    let top = container.scrollTop;
    let height = container.offsetHeight

    if (top > 0) {
      scrollBy(0, -height, container);
    }
  } else {
    let left = container.scrollLeft;
    if (left > 0) {
      scrollBy(-delta, 0, container);
      fixPosition(container.scrollLeft)
    }
  }

  return container
}

export const getParagraphs = (children, paragraphs = [], parentIndex = null) => {
  children = [].slice.call(children)

  for (let i=0; i< children.length; i++) {
    let el = children[i]
    el.parentIndex = parentIndex
    paragraphs.push(el)
    let index
    if(!parentIndex) {
      index = paragraphs.length-1
    }
    if (el.children.length > 0) {
      paragraphs = getParagraphs(el.children, paragraphs, index)
    }
  }

  return paragraphs
}

export const isTableCell = (el) => tableElements.includes(el.nodeName.toLowerCase())

export const isTable = (el) => {
  if (el.id === 'viewer-content') return false
  if (el.nodeName.toLowerCase() === 'table') {
    return el
  } else if (el.parentElement) {
    return isTable(el.parentElement)
  }
  return false
}

export const isMultiColumnTable = (table) => {
  let trCount = 0
  let tdCount = 0
  let children = [].slice.call(table.children)

  children.forEach(tableEl => {
    if (tableEl.nodeName.toLowerCase() === 'tr') {
      trCount++
      let children = [].slice.call(tableEl.children)
      children.forEach(el => {
        if (el.nodeName.toLowerCase() === 'td') tdCount++
      })
    } else if (tableEl.nodeName.toLowerCase() === 'tbody') {
      let children = [].slice.call(tableEl.children)
      children.forEach(el => {
        if (el.nodeName.toLowerCase() === 'tr') {
          trCount++
          let elChildren = [].slice.call(el.children)
          elChildren.forEach(elInside => {
            if (elInside.nodeName.toLowerCase() === 'td') tdCount++
          })
        }
      })
    }
  })
  return trCount > 1 && tdCount > 1 ? true : false
}

export const getTextOffs = (el, offs = 0) => {
  if (el.textContent.length > 0) {
    offs += el.textContent.length
  }
  if (el.children.length > 0) {
    let children = [].slice.call(el.children)
    children.forEach(item => {
      offs = getTextOffs(item, offs)
    })
  }
  return offs
}

export const getTotalSize = (el, lng = 0, withLogs = false) => {
  let text = ''
  let textLng = 0
  let type = el.nodeName.toLowerCase()
  let classList = el.classList
  let parent = el.parentElement.nodeName.toLowerCase()

  if (withLogs) {
    console.log('el', el);
    console.log('type', type)
  }

  if ((textNodes.indexOf(type) > -1 || classList.contains('v')) && (parent !== 'p' && parent !== 'text-author')) {
    text = $(el).text()
    textLng = text.length
    if (el.innerHTML.indexOf('<p') > -1) {
      if (type === 'date' || type === 'epigraph') {
        textLng = 0
      } else {
        textLng = el.innerHTML.indexOf('<p')
      }
    }
  }

  if (withLogs) {
    console.log('textLng', textLng)
  }

  return lng + textLng
}

export const getTotalStorageSize = (children, lng = 0) => {
  children.forEach(child => lng = getTotalSize(child, lng))
  return lng
}

export const pageLayout = (storage, pFirst, isTable, textOffs, pIndex) => ({
  storage: storage,
  pFirst: pFirst,
  isTable: isTable,
  textOffs: textOffs,
  pIndex: pIndex
})

export const setId = (el, num) => {
  el.setAttribute( 'page-num', num)
  if (!el.getAttribute('id')) {
    el.setAttribute('id', 'page-' + num)
  }
  el.classList.add('first-in-page')
  el.classList.add('page')
}

export const getXmlTextByCharset = (xmlText, matches) => {
  let parsed = ''
  for (let i=0; i<matches.length; i++) {
    let match = matches[i];
    let xml = new TextDecoder(match.charsetName).decode(xmlText);
    let parser = new DOMParser();
    let dom = parser.parseFromString(xml,"text/xml");
    let isError = dom.children[0].children[0].children[0].nodeName === 'parsererror'
    if (!isError) {
      parsed = xml
      break
    }
  }
  return parsed
}

export const createPages = (storages = []) => {
  let pageLoutVect = []
  let sectionMap = {
    fst_page: 1
  }
  let textOffs = 0
  let firstPar = 0

  for (let st=0; st < storages.length; st++) {
    let storage = storages[st]
    if (storage.nodeName.toLowerCase() === 'epigraph') continue
    let paragraphs = getParagraphs(storage.children)

    let pcnt = paragraphs.length
    if (pcnt === 0) continue

    let textLeng = -1

    for (let par=0; par < pcnt; par++) {
      let zltp = paragraphs[par]
      let zltpType = zltp.nodeName.toLowerCase()

      if (pageLoutVect.length > 0) {
        zltp.setAttribute( 'page-num', pageLoutVect.length)
      }

      if (skipTags.indexOf(zltpType) > -1 && !zltp.classList.contains(('v'))) continue
      let parent = paragraphs[zltp.parentIndex]

      if (parent && (isTableCell(zltp) || isTableCell(parent)) ) {
        let te = isTable(parent)
        if (te && isMultiColumnTable(te)) {
          let firstIndex = 0
          for (let t=0; t < pcnt; t++) {
            let el = paragraphs[t]
            if (el === te) firstIndex = t+1
          }
          pageLoutVect.push(pageLayout(st, firstPar+par, true, textOffs+getTextOffs(zltp), par))
          setId(parent, pageLoutVect.length)
          let pCount = getParagraphs(te.children).length
          par = firstIndex + pCount - 1
          textLeng = -1
          for (let p=0; p < pCount; p++) {
            zltp = paragraphs[firstIndex + p]
            zltp.inTable = 1
          }
          continue
        }
      }
      let  tl = getTotalSize(zltp, 0)

      if (textLeng === -1) {
        pageLoutVect.push(pageLayout(st, firstPar+par, false, textOffs+getTextOffs(zltp), par))
        setId(zltp, pageLoutVect.length)
        textLeng = tl
        continue
      }
      if (textLeng + tl < 2048) {
        textLeng += tl
        continue
      }

      pageLoutVect.push(pageLayout(st, firstPar+par, false, textOffs+getTextOffs(zltp), par))
      setId(zltp, pageLoutVect.length)
      textLeng = tl
    }
    firstPar += paragraphs.length
    textOffs += getTotalStorageSize(paragraphs)
  }
  sectionMap.pages = pageLoutVect
  sectionMap.lst_page = pageLoutVect.length
  sectionMap.storages = storages

  return sectionMap;
}

export const removeHashFromUrl = () =>
{
  let uri = window.location.toString();
  if (uri.indexOf("#") > 0) {
    let clean_uri = uri.substring(0, uri.indexOf("#"));
    window.history.replaceState({}, document.title, clean_uri);
  }
}

export const handleSelectionChange = (el) => {
  const textSelection = getTextSelection(el);

  if (textSelection !== null) {
    return textSelection
  }
  return {start: 0,end: 0}
}

export const getTextSelection = function (editor) {
  const selection = window.getSelection();

  if (selection != null && selection.rangeCount > 0) {
    const range = selection.getRangeAt(0);
    return {
      start: getTextLength(editor, range.startContainer, range.startOffset),
      end: getTextLength(editor, range.endContainer, range.endOffset)
    };
  } else
    return null;
}

export const getTextLength = function (parent, node, offset) {
  let textLength = 0;

  if (!node) return 0

  if (node.nodeName.toLowerCase() === '#text')
    textLength += offset;
  else for (let i = 0; i < offset; i++)
    textLength += getNodeTextLength(node.childNodes[i]);

  if (node !== parent)
    textLength += getTextLength(parent, node.parentNode, getNodeOffset(node));

  return textLength;
}

export const getNodeTextLength = function (node) {
  let textLength = 0;

  if (!node) return 0

  if (node.nodeName.toLowerCase() === 'br')
    textLength = 1;
  else if (node.nodeName.toLowerCase() === '#text')
    textLength = node.nodeValue.length;
  else if (node.childNodes != null)
    for (let i = 0; i < node.childNodes.length; i++)
      textLength += getNodeTextLength(node.childNodes[i]);

  return textLength;
}

export const getNodeOffset = function (node) {
  return node == null ? -1 : 1 + getNodeOffset(node.previousSibling);
}

export const selectAndHighlightRange = (el, start, end, isHighlight, color) => {
  setSelectionRange(el, start, end);
  if(isHighlight) {
    highlight(color);
  }
}

export const getTextNodesIn = (node) => {
  let textNodes = [];
  if (node.nodeType === 3) {
    textNodes.push(node);
  } else {
    let children = node.childNodes;
    for (var i = 0, len = children.length; i < len; ++i) {
      textNodes.push.apply(textNodes, getTextNodesIn(children[i]));
    }
  }
  return textNodes;
}

export const makeEditableAndHighlight = (colour) => {
  let sel = window.getSelection();
  let range
  if (sel.rangeCount && sel.getRangeAt) {
    range = sel.getRangeAt(0);
  }
  document.designMode = "on";
  if (range) {
    sel.removeAllRanges();
    sel.addRange(range);
  }
  // Use HiliteColor since some browsers apply BackColor to the whole block
  if (!document.execCommand("HiliteColor", false, colour)) {
    document.execCommand("BackColor", false, colour);
  }
  document.designMode = "off";
}

export const highlight = (colour) => {
  let range
  if (window.getSelection) {
    // IE9 and non-IE
    try {
      if (!document.execCommand("BackColor", false, colour)) {
        makeEditableAndHighlight(colour);
      }
    } catch (ex) {
      makeEditableAndHighlight(colour)
    }
  } else if (document.selection && document.selection.createRange) {
    // IE <= 8 case
    range = document.selection.createRange();
    range.execCommand("BackColor", false, colour);
  }
}

export const setSelectionRange = (el, start, end) => {
  if (document.createRange && window.getSelection) {
    let range = document.createRange();
    range.selectNodeContents(el);
    let textNodes = getTextNodesIn(el);
    let foundStart = false;
    let charCount = 0, endCharCount;

    for (let i = 0; i < textNodes.length; i++ ) {
      let textNode = textNodes[i]
      endCharCount = charCount + textNode.length;
      if (!foundStart && start >= charCount && (start < endCharCount || (start === endCharCount && i <= textNodes.length))) {
        range.setStart(textNode, start - charCount);
        foundStart = true;
      }
      if (foundStart && end <= endCharCount) {
        range.setEnd(textNode, end - charCount);
        break;
      }
      charCount = endCharCount;
    }

    let sel = window.getSelection();
    sel.removeAllRanges();
    sel.addRange(range);
  } else if (document.selection && document.body.createTextRange) {
    let textRange = document.body.createTextRange();
    textRange.moveToElementText(el);
    textRange.collapse(true);
    textRange.moveEnd("character", end);
    textRange.moveStart("character", start);
    textRange.select();
  }
}

export const getFb2Position = (anchor) => {
  if (!anchor) return false
  return parseInt(anchor.split('page=')[1].split('&')[0], 10) + 1
}

export const getFb2Offs = (anchor) => {
  let offs = anchor.split('offs=')[1]
  return offs ? parseInt(offs, 10) : false
}

export const getFb2Over = (str) => {
  let over =  str.split('&over=')[1]
  return over ? parseInt(over, 10) : false
}

export const createHighlight = (svg, selectionRange, selectedText, color, pageStart, pageEnd = false, uuid = false, isTable = false, eventEmmiter, offs = false) => {
  let filtered = filteredRanges(selectionRange)
  if (filtered.length === 0) return {}
  let g = svg.append('g')
  let offset = g._groups[0][0].getBoundingClientRect()
  if (!offs) offs = getOffset(selectionRange, pageStart, pageEnd, isTable)

  g.attr('data-text', selectedText)

  for (let i = 0, len = filtered.length; i < len; i++) {
    let r = filtered[i];
    let rect = g.append('rect')
    rect.attr('x', r.left - offset.left)
      .attr('y', r.top - offset.top)
      .attr('height', r.height)
      .attr('width', r.width)
      .attr('fill', color)
      .attr('fill-opacity', 0.3)
      .attr('data-begin', offs.start)
      .attr('data-end', offs.end)
    if (uuid) {
      rect.attr('data-uuid', uuid)
    }
  }

  return {
    offs: offs,
    g: g._groups[0][0]
  }
}

export const getTextNodes = (elems) => {
  let textNodes = [];
  for (let i=0; i < elems.length; i++) {
    let node = elems[i]
    if (node.nodeType === 3) {
      textNodes.push(node);
    } else {
      let children = node.childNodes;
      for (let l = 0, len = children.length; l < len; ++l) {
        textNodes.push.apply(textNodes, getTextNodesIn(children[l]));
      }
    }
  }

  return textNodes;
}

export const getElements = (pageNum, isTable = false) => {
  let elems = ['p']
  if (isTable) elems = ['th', 'td']

  let str = ''
  for (let i=0; i < elems.length; i++) {
    let el = elems[i]
    if (str.length > 0) str += ','
    if (isTable) {
      str += 'table[page-num="'+pageNum+'"] ' + el
    } else {
      str += el+'[page-num="'+pageNum+'"]'
    }
  }
  return $(str)
}

export const createSelection = (pageStart, pageEnd, start, end, isTable = false) => {
  let range = document.createRange()
  if (isTable) pageEnd = pageStart

  const getCharPosition = (pageElements, position, isTable) => {
    let offs = 0
    for (let i=0; i < pageElements.length; i++) {
      let el = pageElements[i]
      let text = $(el).text()
      let node = el.nodeName.toLowerCase()
      offs += text.length

      if (node === 'p' || isTable) {
        if (position >= offs) {
          position--
        } else {
          break
        }
      }
    }
    return position
  }

  const setRange = (range, textNodes, start, end) => {
    let foundStart = false
    let charCount = 0
    let endCharCount

    for (let i = 0; i < textNodes.length; i++ ) {
      let textNode = textNodes[i]
      endCharCount = charCount + textNode.length;

      if (start !== false && !foundStart && start >= charCount && start < endCharCount) {
        let lng = textNode.length
        let offset = start - charCount

        if (offset > lng || offset < 0) break

        range.setStart(textNode, offset);
        foundStart = true;
      }
      if ((!start || foundStart) && end <= endCharCount) {
        let lng = textNode.length
        let offset = end - charCount
        if (offset > lng || offset < 0) break

        range.setEnd(textNode, end - charCount);
        break;
      }
      charCount = endCharCount;
    }

    return range;
  }

  let pageElements = getElements(pageStart, isTable)
  start = getCharPosition(pageElements, start, isTable)
  let textNodes = getTextNodes(getElements(pageStart, isTable))

  if (!isTable) pageElements = getElements(pageEnd, isTable)
  end = getCharPosition(pageElements, end, isTable)
  end++

  range = setRange(range, textNodes, start, end)
  if (pageStart !== pageEnd) {
    textNodes = getTextNodes(getElements(pageEnd, isTable))
    range = setRange(range, textNodes, false, end)
  }

  return range
}

export const saveSelection = () => {
  if (window.getSelection) {
    let sel = window.getSelection();
    if (sel.getRangeAt && sel.rangeCount) {
      return sel.getRangeAt(0);
    }
  } else if (document.selection && document.selection.createRange) {
    return document.selection.createRange();
  }
  return null;
}

export const restoreSelection = (range) => {
  if (range) {
    if (window.getSelection) {
      var sel = window.getSelection();
      sel.removeAllRanges();
      sel.addRange(range);
    } else if (document.selection && range.select) {
      range.select();
    }
  }
}

export const filteredRanges = (range) => {
  let rects = Array.from(range.getClientRects());
  let filtered = [];

  rects.forEach(function(rect) {
    filtered.push(rect)

    for (let i = 0; i < filtered.length; i++) {
      let item = filtered[i];
      if (
        (item.y >= rect.y && (item.y+item.height) <= (rect.y+rect.height) && item.x+item.width >= rect.x+rect.width) ||
        (item.y <= rect.y && (item.y+item.height) >= (rect.y+rect.height) && item.x+item.width >= rect.x+rect.width)
      ) {
        if (rect.width <= item.width) {
          filtered[i] = rect;
        }
      }
    }
  })

  let uniqueNames = [];
  filtered.forEach(function(el){
    if(uniqueNames.indexOf(el) === -1) uniqueNames.push(el)
  })

  return uniqueNames
}

export const getNextEl = (el) => {
  if (el.nextElementSibling && el.nextElementSibling.nodeName.toLowerCase() === 'img') {
    let next = el.nextElementSibling.nextElementSibling
    if ($(next).hasClass('empty-line')) {
      return next.nextElementSibling
    }
    return next
  } else if (el.nextElementSibling) {
    return el.nextElementSibling
  } else {
    return getNextEl(el.parentElement)
  }
}

export const findOffset = (page, textFlow) => {
  let elems = $('p[page-num="'+page+'"]')
  let viewerContent = document.getElementById('viewer-content')
  let viewer = document.getElementById('viewer')

  let overLimit = viewerContent.offsetWidth
  let scrollOffs = window.pageXOffset || document.documentElement.scrollLeft
  if (textFlow === 'scrolling') {
    overLimit = viewer.offsetHeight + viewer.offsetTop
    scrollOffs = window.pageYOffset || document.documentElement.scrollTop
  }

  let offset = 0
  let gotIt = false
  for (let i=0; i < elems.length; i++) {
    let el = elems[i]
    let rect = el.getBoundingClientRect();
    let left = textFlow === 'scrolling' ? rect.top + scrollOffs : rect.left + scrollOffs

    if (left > 0 && left <= overLimit) {
      gotIt = true
      break
    }

    let text = $(el).text()
    if ($(el).hasClass('empty-line')) {
      offset += 1
    } else {
      offset += text.length + 1
    }
  }
  if (!gotIt) offset = 0
  return offset
}

export const getOffset = (range, pageStart, pageEnd, isTable = false) => {
  if (isTable) pageEnd = pageStart

  const getContainer = (range, isStart = true) => ({
    offs:   isStart ? range.startOffset : range.endOffset,
    text:   isStart ? range.startContainer : range.endContainer,
    parent: isStart ? range.startContainer.parentElement :
            range.endContainer.parentElement
  })

  const getCharPosition = (pageElements, textNodes, container, isTable) => {
    let offs = 0
    let p = false

    for (let i=0; i < textNodes.length; i++) {
      let textNode = textNodes[i]
      let parent = textNode.parentElement

      if (textNode === container.text) {
        offs += container.offs
        p = parent.closest('p')
        if (isTable) p = parent.closest('td') || parent.closest('th')
        break
      } else {
        offs += textNode.length
      }
    }
    for (let i=0; i < pageElements.length; i++) {
      let el = pageElements[i]
      if (el === p) {
        break
      } else {
        offs++
      }
    }
    return offs
  }

  let pageElements = getElements(pageStart, isTable)
  let textNodes = getTextNodes(pageElements)
  let startContainer = getContainer(range)
  let start = getCharPosition(pageElements, textNodes, startContainer, isTable)

  pageElements = getElements(pageEnd, isTable)
  textNodes = getTextNodes(pageElements)
  let endContainer = getContainer(range, false)
  let end = getCharPosition(pageElements, textNodes, endContainer, isTable)
  end--

  return {
    start: start,
    end: end
  }
}

export const getBookmarkOffsEl = (page, offs) => {
  let pageElements = $('p[page-num="'+page+'"]')
  let pageText = 0
  let offsEl

  for (let i=0; i < pageElements.length; i++) {
    let el = pageElements[i]
    let lng = $(el).text().length
    pageText += lng

    if (pageText >= offs) {
      offsEl = el
      break
    }
  }
  return offsEl
}

export const addNoteInPage = (range, note, setSelectedNote, page, offs, noteText, text, onSelected,
                              setEditNoteText, changeHighlighModalPosition,  toggleActiveHighlight,
                              activeHighlight, setOpenAddNote, uuid = false, isTable = false) => {
  const readerElems = {
    header: document.getElementsByClassName('Header')[0],
    content: document.getElementById('viewer-content'),
    notes: document.getElementsByClassName('noteLayer')[0]
  }

  const fixMarkPosition = (offs, level = 0) => {
    let startOffs = offs
    let marks = $('.mark')
    for (let i=0; i < marks.length; i++) {
      let mark = marks[i]
      let markTop = parseInt(mark.style.top.slice(0, -2), 10)
      let markLeft = parseInt(mark.style.left.slice(0, -2), 10)

      if (Math.floor(markTop) === Math.floor(offs.top) &&
        Math.floor(markLeft) === Math.floor(offs.left)) {
        level++
        if (level % 2 !== 0) {
          offs.top = markTop + 5
          offs.left = markLeft + 5
        }
        if (startOffs !== offs) offs = fixMarkPosition(offs, level)
        break
      }
    }
    return offs
  }

  const getMarkPosition = (range, isTable) => {
    let parent = range.startContainer.parentElement
    if (!parent) return
    let rect = range.getClientRects()[0]

    const getTop = () => {
      if (isTable) {
        rect = parent.getBoundingClientRect()
      }
      let top = rect.top - $(readerElems.content).offset().top
      let h = rect.height
      return top + h/2 - 11.5
    }

    const getLeft = () => {
      if (isTable) {
        parent = parent.closest('table')
      } else if (parent.nodeName.toLowerCase() !== 'p') {
        parent = parent.closest('p')
      }
      let left = parent.offsetLeft
      let parentRects = parent.getClientRects()
      let index = 1
      for (let i=0; i < parentRects.length; i++) {
        let parentRect = parentRects[i]
        if (parentRect.left <= rect.left &&
        parentRect.right >= rect.right) {
          index = i+1
        }
      }

      left += parent.offsetWidth*index+66*(index-1)
      return left
    }

    let offs = {
      top: getTop(),
      left: getLeft()
    }
    return fixMarkPosition(offs)
  }

  const onMarkClick = (e) => {
    setEditNoteText(noteText)
    onSelected(range, text, '', e, offs)
    setSelectedNote(note)
    let openClass = 'openEditNote'
    onMouseUp(e, changeHighlighModalPosition, toggleActiveHighlight, activeHighlight, onSelected, setOpenAddNote, openClass, true)
  }

  const setMark = (position, offs, uuid) => {
    let link = document.createElement('a')
    link.classList.add('mark')
    link.dataset.begin = offs.start
    link.dataset.end = offs.end
    link.dataset.noteText = noteText
    if (uuid) {
      link.dataset.uuid = uuid
    }

    readerElems.notes.append(link)
    link.style.top = position.top + 'px'
    link.style.left = position.left + 'px'
    link.addEventListener('click', onMarkClick)
  }

  let position = getMarkPosition(range, isTable)
  if (!position) return
  setMark(position, offs, uuid)
}

export const fb2Search = (q, content) => {
  let matches = []
  let textNodes = getTextNodes(content)
  let query = q.toLowerCase()

  for (let i=0; i < textNodes.length; i++) {
    let node = textNodes[i]
    let text = node.textContent.toLowerCase()

    let pos
    let limit = 70
    let last = -1

    while (pos !== -1) {
      pos = text.indexOf(query, last + 1);

      if (pos !== -1) {
        let range = document.createRange();
        range.setStart(node, pos);
        range.setEnd(node, pos + query.length);

        let excerpt = ''
        let page = parseInt(node.parentElement.getAttribute('page-num'), 10)
        let pageStart = parseInt(range.startContainer.parentElement.getAttribute('page-num'), 10)
        let pageEnd = parseInt(range.endContainer.parentElement.getAttribute('page-num'), 10)

        if (node.textContent.length < limit) {
          excerpt = node.textContent;
        } else {
          text = node.textContent.substring(pos - limit / 2, pos + limit / 2);
          excerpt = "..." + text + "...";
        }

        if (!Number.isNaN(page)) {
          matches.push({
            page: page,
            text: excerpt,
            chapterTitle: '',
            range: {
              selectedRange: range,
              pageStart: pageStart,
              pageEnd: pageEnd,
              text: text,
            }
          })
        }
      }

      last = pos
    }
  }

  if (matches.length === 0) {
    matches.push({notFound: true})
  }

  return matches
}

const snapSelectionToWord = () => {
  let sel;

  if (window.getSelection && (sel = window.getSelection()).modify) {
    sel = window.getSelection();
    if (!sel.isCollapsed) {
      let range = document.createRange();
      range.setStart(sel.anchorNode, sel.anchorOffset);
      range.setEnd(sel.focusNode, sel.focusOffset);
      let backwards = range.collapsed;
      range.detach();

      let endNode = sel.focusNode, endOffset = sel.focusOffset;
      sel.collapse(sel.anchorNode, sel.anchorOffset);

      let direction = [];
      if (backwards) {
        direction = ['backward', 'forward'];
      } else {
        direction = ['forward', 'backward'];
      }

      sel.modify("move", direction[0], "character");
      sel.modify("move", direction[1], "word");
      sel.extend(endNode, endOffset);
      sel.modify("extend", direction[1], "character");
      sel.modify("extend", direction[0], "word");
    }
  } else if ( (sel = document.selection) && sel.type !== "Control") {
    let textRange = sel.createRange();
    if (textRange.text) {
      textRange.expand("word");
      while (/\s$/.test(textRange.text)) {
        textRange.moveEnd("character", -1);
      }
      textRange.select();
    }
  }

  return sel
}

export const checkIfHighlight = (highlights) => {
  let selectionRange = snapSelectionToWord()

  if (selectionRange.rangeCount === 1) {
    for (let i=0; i < highlights.length; i++) {
      let note = highlights[i]

      let begin = getFb2Offs(note.quotation.begin)
      let end = getFb2Over(note.quotation.end)
      let pageBegin = getFb2Position(note.quotation.begin)
      let pageEnd = getFb2Position(note.quotation.end)

      let selectedRange = createSelection(pageBegin, pageEnd, begin, end)

      let cond1 = selectedRange.startContainer === selectionRange.focusNode && selectedRange.startOffset <= selectionRange.focusOffset
      let cond2 = selectedRange.endContainer === selectionRange.focusNode && selectedRange.endOffset >= selectionRange.focusOffset

      if (selectedRange.startContainer === selectedRange.endContainer) {
        if (cond1 && cond2) {
          return {selectedRange: selectedRange, uuid: note.uuid}
        }
      } else {
        if (cond1 || cond2) {
          return {selectedRange: selectedRange, uuid: note.uuid}
        }
      }
    }
  }

  return false
}

export const getCurrPage = (page, textFlow, getFirst) => {
  let viewerContent = document.getElementById('viewer-content')
  let viewer = document.getElementById('viewer')
  let visiblePageTags = $('.xml-page .first-in-page')
  let closest = ''
  for (let i=page-20; i<=page+20; i++) {
    if (i!==page-20) closest += ','
    closest += 'p[page-num="'+i+'"]'
  }
  closest = $(closest)
  let currPage = page
  page = false
  for (let i=0; i < visiblePageTags.length; i++) {
    let el = visiblePageTags[i]
    let scrollLeft
    let left
    let limit

    let rect = el.getBoundingClientRect();
    if (textFlow === 'scrolling') {
      scrollLeft = window.pageYOffset || document.documentElement.scrollTop
      left = rect.top + scrollLeft
      limit = viewer.offsetHeight + viewer.offsetTop
    } else {
      scrollLeft = window.pageXOffset || document.documentElement.scrollLeft
      left = rect.left + scrollLeft
      limit = viewerContent.offsetWidth
    }

    if (left > 0 && left <= limit) {
      page = parseInt(el.getAttribute('page-num'), 10)
      if (getFirst) break
    }
  }
  if (!page) {
    for (let i=0; i < closest.length; i++) {
      let el = closest[i]
      let scrollLeft
      let left
      let limit

      let rect = el.getBoundingClientRect();
      if (textFlow === 'scrolling') {
        scrollLeft = window.pageYOffset || document.documentElement.scrollTop
        left = rect.top + scrollLeft
        limit = viewer.offsetHeight + viewer.offsetTop
      } else {
        scrollLeft = window.pageXOffset || document.documentElement.scrollLeft
        left = rect.left + scrollLeft
        limit = viewerContent.offsetWidth
      }

      if (left > 0 && left <= limit) {
        page = parseInt(el.getAttribute('page-num'), 10)
        if (getFirst) break
      }
    }
  }
  if (!page) page = currPage
  return page
}

const table = ['tr', 'td', 'tbody', 'th', 'table']

const checkElForGetPage = (el) => {
  let page

  if (el.nodeName.toLowerCase() === 'section') {
    page = el.getAttribute('page-num') - 1
  } else if (table.indexOf(el.parentElement.nodeName.toLowerCase()) > -1 ||
    el.parentElement.closest('td') || el.parentElement.closest('th')
  ) {
    page = el.parentElement.closest('table').getAttribute('page-num') - 1
  } else {
    page = el.parentElement.getAttribute('page-num') - 1
  }
  return page
}

export const checkIfTable = (el) => {
  el = el[0] ? el[0] : el
  if (!el || el.length === 0) return false

  let cond1 = table.indexOf(el.nodeName.toLowerCase()) > -1
  let cond2 = table.indexOf(el.parentElement.nodeName.toLowerCase()) > -1
  let cond3 = el.parentElement.closest('td') !== null
  let cond4 = el.parentElement.closest('th') !== null

  return cond1 || cond2 || cond3 || cond4
}

export const getPageInSelectedRange = (selectedRange) => {
  let sContainer = selectedRange.startContainer
  let eContainer = selectedRange.endContainer
  let pages = {
    start: checkElForGetPage(sContainer),
    end: checkElForGetPage(eContainer),
    isTable: checkIfTable(sContainer)
  }
  return pages
}

const replacedTags = {
  'title': {
    'tag': 'div',
    'classes': 'title'
  },
  'image': {
    'tag': 'img',
    'classes': ''
  },
  'empty-line': {
    'tag': 'p',
    'classes': 'empty-line'
  },
  'subtitle': {
    'tag': 'p',
    'classes': 'subtitle'
  },
  'cite': {
    'tag': 'div',
    'classes': 'cite'
  },
  'v': {
    'tag': 'div',
    'classes': 'v'
  },
  'section': {
    'tag': 'div',
    'classes': ''
  }
}

Element.prototype.spawn = function(strTN) {
  let tName = ({original: this.tagName.toUpperCase(), change: strTN.toUpperCase()}); if (tName.original === tName.change) { return; }
  // eslint-disable-next-line no-useless-escape
  let fragment = document.createRange().createContextualFragment(this.outerHTML.replace(new RegExp("(^\<\\b" + tName.original + "\\b)|(\\b" + tName.original + "\\b\>$)","gi"), function(x){return(x.toUpperCase().replace(tName.original, tName.change));}));
  return(fragment.firstChild);
}

const replaceTags = async (storage) => {
  const promises = Object.keys(replacedTags).map(async (replacedTag) => {
    const tags = [].slice.call(storage.getElementsByTagName(replacedTag));

    const tagsPromises = tags.map(async tag => {
      const newTag = tag.spawn(replacedTags[replacedTag].tag);
      newTag.className += (newTag.className.length ? ' ' : '') + replacedTags[replacedTag].classes

      tag.parentNode.replaceChild(newTag, tag);
    });

    return await Promise.all(tagsPromises);
  });

  return await Promise.all(promises).then(() => storage.children);
}

const createStorages = async (xml) => {
  let storages = []

  for (let i=0; i < xml.length; i++) {
    let el = xml[i]
    if (el.nodeName.toLowerCase() === 'body') {
      storages.push(el)
    }
  }

  let collection = []

  const promises = storages.map(async storage => {
    return await replaceTags(storage).then(htmlCollection => {
      collection = collection.concat([].slice.call(htmlCollection))
    })
  })

  return await Promise.all(promises).then(() => collection);
}

export const parseFb2Xml = async (data, setPageCount, setPages, setBookReady, onLoadChapters, textFlow, onLoad,
                            onChangeTextSize, textSize, onChangeTextColor, textColor, onChangeTextFont,
                            textFont, onChangeViewMode, findCurrPage, currPage, onSaveReaderPosition,
                            updateReadPosition, bookId, access_token, refresh_token, onAddHighlights,
                            addState, onFixTextPosition) => {
  let viewerContent = document.getElementById('viewer-content')
  let viewer = document.getElementById('viewer')
  let readerContent = document.getElementsByClassName('fb2Reader')[0]

  let parser = new DOMParser();
  let xml = parser.parseFromString(data,"text/xml");

  let storages = await createStorages(xml.children[0].children);
  let pages = await createPages(storages);

  setPageCount(pages.pages.length)
  setPages(pages)
  setBookReady(true)

  let xmlPage = document.createElement('div')
  xmlPage.classList.add('xml-page')
  viewerContent.append(xmlPage)
  let noteLayer = document.createElement('div')
  noteLayer.classList.add('noteLayer')
  viewerContent.append(noteLayer)
  let tmp = ''
  onLoadChapters()
  for (let i=0;i<pages.storages.length;i++) {
    let el = pages.storages[i]
    tmp += el.outerHTML
  }

  let textWrap = document.createElement('div')
  textWrap.classList.add('textWrap')
  xmlPage.append(textWrap)
  $(textWrap).html(tmp)

  let pageClass = ''
  switch(textFlow) {
    case '1page':
      pageClass = 'one-page'
      break;
    case '2page':
      pageClass = 'two-page'
      break;
    case 'scrolling':
      pageClass = textFlow
      break;
    default:
      pageClass = ''
  }

  xmlPage.classList = 'xml-page ' + pageClass
  viewerContent.classList = pageClass
  if (readerContent) readerContent.classList = 'fb2Reader ' + pageClass

  viewer.style.maxWidth = ''
  let vWidth = viewerContent.offsetWidth
  if (textFlow !== '2page') {
    vWidth = getWidthByFontSize(textSize)
    viewer.style.maxWidth = vWidth + 'px'
  }

  $('.empty-line').each((i,line) => line.innerText = '')

  let paddingRihgt = 44
  if (textFlow === '2page') {
    let w = vWidth/2 - 88*2
    if (w <= 224) w = vWidth - 66*2
    textWrap.style.columnWidth = w + 'px'
    paddingRihgt = 44
  } else if (textFlow === '1page') {
    textWrap.style.columnWidth = (vWidth - 66*2) + 'px'
    paddingRihgt = 33
  } else {
    textWrap.style.columnWidth = ''
    paddingRihgt = ''
  }
  textWrap.style.width = vWidth + 'px'

  let annotationLayer = document.createElement('div')
  annotationLayer.classList.add('svgWrapper')

  textWrap.style.width = vWidth + 'px'
  let prevW = textWrap.scrollWidth
  let wait = setInterval(() => {
    if (prevW === textWrap.scrollWidth) {
      xmlPage.style.width = textWrap.scrollWidth + paddingRihgt + 'px'
      annotationLayer.style.width = textWrap.scrollWidth + paddingRihgt + 'px'
      noteLayer.style.width = textWrap.scrollWidth + paddingRihgt + 'px'
      clearInterval(wait)
    } else {
      prevW = textWrap.scrollWidth
    }
  }, 500)

  $('.xml-page .textWrap > .title').wrap('<section />')

  viewerContent.append(annotationLayer)
  let svg = d3.select(annotationLayer).append('svg')
  onLoad(svg)

  onChangeTextSize(textSize, true)
  onChangeTextColor(textColor)
  onChangeTextFont(textFont, true)
  onChangeViewMode(textFlow, true)

  let binaries = xml.getElementsByTagName('binary')

  for (let i=0;i<binaries.length;i++) {
    let binary = binaries[i]
    let id = binary.id
    let imgSrc = binary.innerHTML
    let type = binary.getAttribute('content-type')

    $('#viewer img').each((i, img) => {
      let attributes = img.attributes
      for (let k=0; k<attributes.length;k++) {
        let key = attributes[k].name
        if (key.split(':')[1] === 'href' && $(img).attr(key) === '#' + id) {
          $(img).attr('src', 'data:' + type + ';base64,' + imgSrc)
          $(img).css('max-height', vWidth - 40)
          break;
        }
      }
    })
  }

  $('#viewer .xml-page a').each((i, a) => {
    let attributes = a.attributes
    for (let k=0; k<attributes.length;k++) {
      let key = attributes[k].name
      if (key.split(':')[1] === 'href') {
        $(a).attr('href', $(a).attr(key))
        break;
      }
    }
  });
  $('#viewer .xml-page a').on('click', e => {
    e.preventDefault()
    if (!e.target.getAttribute('href')) return
    if (e.target.getAttribute('href').indexOf('http') > -1) {
      window.location = e.target.getAttribute('href')
      return
    }
    let id = e.target.getAttribute('href').slice(1)
    let el = $('#' + id)

    if (el.length === 0) return
    let section = el.closest('section')
    if (section.is(':visible')) {
      //window.location = '#' + id
      removeHashFromUrl()
    }
    if (section[0] === el[0]) {
      if (el.parent().get(0).tagName.toLowerCase() === 'section') {
        section = el.parent()
      }
    }

    addState()
    onFixTextPosition(id, null, 'id')
    findCurrPage()
    onSaveReaderPosition()
  });

  setTimeout(() => onAddHighlights(), 1000)
  findCurrPage(true, currPage)
  if (textFlow !== 'scrolling') fixPosition(viewerContent.scrollLeft)
}

const contains = (item, target, x, y) => {
  //let offset = target.getBoundingClientRect();

  const rectContains = (r, x, y) => {
    let top = r.top; //- offset.top;
    let left = r.left; //- offset.left;
    let bottom = top + r.height;
    let right = left + r.width;
    return top <= y && left <= x && bottom > y && right > x;
  }

  let rect = item.getBoundingClientRect();

  if (!rectContains(rect, x, y)) {
    return false;
  }

  let rects = item.getClientRects();
  for (let i = 0, len = rects.length; i < len; i++) {
    if (rectContains(rects[i], x, y)) {
      return true;
    }
  }
  return false;
}

const clone = (e) => {
  let opts = Object.assign({}, e, { bubbles: false });
  try {
    return new MouseEvent(e.type, opts);
  } catch (err) {
    let copy = document.createEvent('MouseEvents');
    copy.initMouseEvent(e.type, false, opts.cancelable, opts.view, opts.detail, opts.screenX, opts.screenY, opts.clientX, opts.clientY, opts.ctrlKey, opts.altKey, opts.shiftKey, opts.metaKey, opts.button, opts.relatedTarget);
    return copy;
  }
}

export const proxyMouse = (target, tracked) => {
  const dispatch = (e) => {
    for (let i = tracked.length - 1; i >= 0; i--) {
      let t = tracked[i];
      let x = e.clientX;
      let y = e.clientY;

      if (e.touches && e.touches.length) {
        x = e.touches[0].clientX;
        y = e.touches[0].clientY;
      }

      if (!contains(t, target, x, y)) {
        continue;
      }

      t.dispatchEvent(clone(e));

      break;
    }
  }

  if (target.nodeName.toLowerCase() === "iframe") {

    try {
      this.target = target.contentDocument;
    } catch (err) {
      this.target = target;
    }
  } else {
    this.target = target;
  }

  let _arr = ['mouseup', 'mousedown', 'click', 'touchstart']; //mousemove
  for (let _i = 0; _i < _arr.length; _i++) {
    let ev = _arr[_i];
    this.target.addEventListener(ev, function (e) {
      return dispatch(e);
    }, false);
  }
}


// WEBPACK FOOTER //
// ./src/utilities/fb2Utilities.js